// Shadow scale — semantic named shadows consumed by component themes
// Uses low-opacity black so they work on both white and colored backgrounds.

export const shadowsFoundation = {
  shadows: {
    // Base elevation scale — bumped intensity for better depth visibility
    xs: '0px 1px 2px rgba(15, 23, 42, 0.08)',
    sm: '0px 2px 4px rgba(15, 23, 42, 0.10), 0px 1px 2px rgba(15, 23, 42, 0.06)',
    md: '0px 6px 12px rgba(15, 23, 42, 0.10), 0px 2px 4px rgba(15, 23, 42, 0.06)',
    lg: '0px 12px 24px rgba(15, 23, 42, 0.12), 0px 4px 8px rgba(15, 23, 42, 0.06)',
    xl: '0px 20px 40px rgba(15, 23, 42, 0.16), 0px 6px 12px rgba(15, 23, 42, 0.08)',
    '2xl': '0px 32px 64px rgba(15, 23, 42, 0.22), 0px 12px 20px rgba(15, 23, 42, 0.12)',
    inner: 'inset 0px 2px 4px rgba(15, 23, 42, 0.08)',
    none: 'none',

    // Focus rings — indigo brand focus ring
    outline: '0 0 0 3px rgba(99, 102, 241, 0.35)',
    'outline-error': '0 0 0 3px rgba(239, 68, 68, 0.30)',

    // Card shadows — stronger to lift cards off the bg
    card: '0px 6px 16px rgba(15, 23, 42, 0.10), 0px 2px 4px rgba(15, 23, 42, 0.06)',
    cardHover: '0px 14px 32px rgba(15, 23, 42, 0.16), 0px 4px 10px rgba(15, 23, 42, 0.10)',
    // Colored glow — indigo brand (#6366F1)
    glowBrand: '0 0 28px rgba(99, 102, 241, 0.30), 0 2px 6px rgba(99, 102, 241, 0.18)',
    glowBrandLg: '0 10px 36px rgba(99, 102, 241, 0.38), 0 3px 10px rgba(99, 102, 241, 0.22)',
    glowSuccess: '0 6px 18px rgba(16, 185, 129, 0.35)',
    glowError: '0 6px 18px rgba(239, 68, 68, 0.35)',
    // Sidebar active — indigo glow
    sidebarActive: '0 4px 16px rgba(99, 102, 241, 0.25), 0 2px 4px rgba(99, 102, 241, 0.14)',
  },
};
